<app-cart-layout>
  <main class="mt-5 pt-4">
    <div class="container">
      <div class="row" style="padding-top: 15px">
        <!--Grid column-->
        <div class="col-lg-8 col-sm-8 col-6">
          <span class="btnItem"><a href="/" class="" data-testid="cart-page-continue-shopping"><i class="fas fa-arrow-left"></i> Continue Shopping</a>
          </span>
        </div>
        <!--Grid column-->
        <div class="col-lg-4 col-sm-4 col-6">
          <a href="javascript:window.print()" class="btnItem float-right" data-testid="cart-page-print"><i class="fas fa-print"></i> Print</a>
        </div>
      </div>

      <!--Grid row-->
      <div class="row" style="padding-top: 15px">
        <!--Grid column-->
        <div class="col-lg-8 col-sm-12 col-12 mb-4">
          <app-product-list></app-product-list>

          <app-product-savedforlater-list></app-product-savedforlater-list>
        </div>
        <!--Grid column-->
        <div class="col-lg-4 col-sm-12 col-12 mb-4">
          <div class="card z-depth-1 sticky" *ngIf="hasItemsInCart">
            <div class="card-body">
              <app-shipping 
                  [pageScope]="'cart'" 
                  class="cart-shipping-widget"
                  data-testid="cart-shipping-widget"
                  style="min-height: 220px"
              >
              </app-shipping>
            </div>
          </div>

          <div class="card z-depth-1 sticky" [ngClass]="{ 'mt-4': hasItemsInCart }">
            <app-summary></app-summary>
          </div>

          <div class="p-3" style="border-radius: 6px; color: #424243; background-color: #f2f4f5">
            <div class="card-body" style="padding-left: 20px">
              <app-contact-us></app-contact-us>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</app-cart-layout>